import PropTypes from 'prop-types';
import { Link as InternalLink } from 'react-router-dom';

import ExternalLink from '@zenbusiness/zui/Link';

const DEFAULT_TARGET = '_blank';

const SmartLink = ({
  children, target, url = '', ...delegated
}) => {
  const isExternal = target === DEFAULT_TARGET || url.startsWith('http');

  if (isExternal) {
    const finalTarget = isExternal && !target ? DEFAULT_TARGET : target;
    const rel = finalTarget === DEFAULT_TARGET ? 'noopener noreferrer' : undefined;

    return (
      <ExternalLink href={url} rel={rel} target={finalTarget} {...delegated}>
        {children}
      </ExternalLink>
    );
  }

  return (
    <InternalLink to={url} {...delegated}>
      {children}
    </InternalLink>
  );
};

SmartLink.propTypes = {
  children: PropTypes.node.isRequired,
  target: PropTypes.string,
  url: PropTypes.string.isRequired
};

export default SmartLink;
